// extracted by mini-css-extract-plugin
module.exports = {"sectionBG":"Section-module--sectionBG--1jsoB","sectionBGColor":"Section-module--sectionBGColor--16Qmr","sectionWrapper":"Section-module--sectionWrapper--1MTRv"};